<template>
	<div class="database page-container">
		<div class="userinfo">
			欢迎登录！用户名：<span class="username">{{userinfo.name}}</span><!-- <span class="role">{{userinfo.role}}</span> -->
			&nbsp;&nbsp;当前时间：<span class="time">{{time}}</span>
		</div>
		<div class="total">
			<div class="title">
				数据统计
			</div>
			<div class="flow">
				<div class="item">
					<div class="key">
						交易总额：
					</div>
					<div class="value">
						{{money}}
					</div>
				</div>
				<div class="item">
					<div class="key">
						用户总数：
					</div>
					<div class="value">
						{{member}}
					</div>
				</div>
				<div class="item">
					<div class="key">
						商品总数：
					</div>
					<div class="value">
						{{commodity}}
					</div>
				</div>
				<div class="item">
					<div class="key">
						订单总数：
					</div>
					<div class="value">
						{{order}}
					</div>
				</div>
				<div class="item">
					<div class="key">
						文章总数：
					</div>
					<div class="value">
						{{article}}
					</div>
				</div>
			</div>
		</div>
		<div class="chart">
			<div class="filter">
				<div class="filter-title">
					最近订单量
				</div>
				<div class="filter-time">
					请选择日期：
					<el-date-picker v-model="timeScope" type="monthrange" range-separator="至"
						start-placeholder="开始日期" end-placeholder="结束日期" @change="dateChange"
						format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss">
					</el-date-picker>
				</div>
			</div>
			<div class="chart-area" id="chart-area">

			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'index',
		data() {
			return {
				userinfo: {
					name: ''
				},
				time: '',
				money: 0,
				member: 0,
				commodity: 0,
				order: 0,
				article: 0,
				timeScope: ['', '']
			};
		},
		computed: {
			getUserInfo() {
				return this.$store.state.admUserInfo
			}
		},
		watch: {
			getUserInfo(userInfo) {
				this.userinfo = userInfo
			}
		},
		methods: {
			getDate() {
				let date = new Date()
				let year = date.getFullYear()
				let month = date.getMonth() + 1
				let day = date.getDate()
				let hour = date.getHours()
				let minute = date.getMinutes()
				this.time = year + '年' + month + '月' + day + '日 ' + hour + ':' + minute
			},
			dateChange() {
				this.fetchChart()
			},
			initEchart(chartData) {
				var chartDom = document.getElementById('chart-area');
				var myChart = this.$echarts.init(chartDom);
				var option;

				option = {
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						}
					},
					grid: {
						left: '3%',
						right: '4%',
						bottom: '3%',
						containLabel: true
					},
					xAxis: {
						type: 'category',
						data: chartData.xAxis
					},
					yAxis: {
						type: 'value'
					},
					series: [{
						data: chartData.series,
						type: 'bar',
						showBackground: true,
						backgroundStyle: {
							color: 'rgba(180, 180, 180, 0.2)'
						}
					}],
					color: ['#0071ff']
				};

				option && myChart.setOption(option);
			},
			fetchData() {
				this.$api.indexStatistics({}, res => {
					if (res.code == 200) {
						this.money = res.data[0]
						this.member = res.data[1]
						this.commodity = res.data[2]
						this.order = res.data[3]
						this.article = res.data[4]
					}
				})
			},
			fetchChart() {
				this.$api.indexCharts({
					startDate: this.timeScope[0],
					endDate: this.timeScope[1],
				}, res => {
					if (res.code == 200) {
						let xAxis = new Array(),series = new Array()
						let list = res.data
						for (let i = 0; i < list.length; i++) {
							xAxis.push(list[i]['riqi'])
							series.push(list[i]['count'])
						}
						let chartData = {
							xAxis: xAxis,
							series: series
						}
						this.initEchart(chartData)
					}
				})
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
			this.userinfo = this.$store.state.admUserInfo
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			this.getDate()
			let interval = setInterval(() => {
				this.getDate()
			}, 60000)
			this.fetchChart()
			this.fetchData()
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	};
</script>

<style lang="less" scoped="scoped">
	.database {
		padding: @vue-spacing-col-base @vue-spacing-row-base;
		box-sizing: border-box;
	}

	.userinfo {
		width: 100%;
		height: 70px;
		background: @vue-bg-color-grey;
		padding-left: @vue-spacing-row-base;
		border-left: 8px solid @vue-border-color-active;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		font-size: @vue-font-size-sm + 2;

		.username {
			color: @vue-text-color-red;
		}

		.role {
			color: @vue-text-color-inverse;
			background: @vue-bg-color-active;
			font-size: @vue-font-size-sm - 2;
			margin: 0px @vue-spacing-row-base;
			padding: 5px 15px;
			border-radius: 20px;
		}

		.time {
			color: @vue-text-color-dg;
		}
	}

	.total {
		width: 100%;
		background: @vue-bg-color-grey;
		margin-top: @vue-spacing-col-lg;
		box-sizing: border-box;
		padding: @vue-spacing-col-base @vue-spacing-row-base @vue-spacing-col-lg @vue-spacing-row-base;
		box-sizing: border-box;

		.title {
			width: 100%;
			height: 40px;
			border-bottom: 1px solid @vue-border-color;
			box-sizing: border-box;
			display: flex;
			align-items: center;
		}

		.flow {
			width: 100%;
			margin-top: @vue-spacing-col-base;
			display: flex;

			.item {
				width: 230px;
				height: 100px + @vue-spacing-col-sm * 2;
				background: @vue-bg-color;
				margin-right: @vue-spacing-row-lg;
				padding: @vue-spacing-col-sm @vue-spacing-row-sm;
				box-sizing: border-box;

				.key,
				.value {
					width: 100%;
				}

				.key {
					height: 40px;
					border-bottom: 1px solid @vue-border-color;
					box-sizing: border-box;
					display: flex;
					align-items: center;
				}

				.value {
					height: 60px;
					display: flex;
					align-items: center;
					color: @vue-text-color-dg;
					font-size: @vue-font-size-base;
					font-weight: bold;
				}
			}
		}
	}

	.chart {
		width: 100%;
		height: calc(100% - 330px);
		margin-top: @vue-spacing-col-lg;
		background: @vue-bg-color-grey;
		padding: @vue-spacing-col-base @vue-spacing-row-base;
		box-sizing: border-box;

		.filter {
			width: 100%;
			height: 50px;
			border-bottom: 1px solid @vue-border-color;
			box-sizing: border-box;
			display: flex;
			justify-content: space-between;

			.filter-title,
			.filter-time {
				height: 100%;
			}

			.filter-title {
				display: flex;
				align-items: center;
			}
		}

		.chart-area {
			width: 100%;
			height: calc(100% - 66px);
			min-height: 330px;
			margin-top: @vue-spacing-col-base;
		}
	}
</style>
